document.addEventListener("DOMContentLoaded", function () {

  const sticky = document.querySelector("[data-q-sticky-atc]");

  if (!sticky) return;

  const productForm = document.querySelector('form[action*="/cart/add"]');

  if (!productForm) return;

  const stickyButton = sticky.querySelector("[data-q-sticky-button]");

  function toggleSticky() {

    const rect = productForm.getBoundingClientRect();

    if (rect.bottom < 0) {
      sticky.classList.add("is-visible");
    } else {
      sticky.classList.remove("is-visible");
    }

  }

  window.addEventListener("scroll", toggleSticky, { passive: true });

  toggleSticky();

  stickyButton.addEventListener("click", function () {

    const realButton =
      productForm.querySelector('button[type="submit"]') ||
      productForm.querySelector('[name="add"]');

    if (realButton) {
      realButton.click();
    }

  });

});